import React from "react";
import { FaYoutube, FaEnvelope } from "react-icons/fa"; // Icons for YouTube & Email
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Shrutilaya Fine Arts. All Rights Reserved.</p>

        {/* Social & Contact Links */}
        <div className="footer-links">
          <a
            href="https://www.youtube.com/@shrutilayafinearts"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our YouTube Channel"
          >
            <FaYoutube className="footer-icon youtube-icon" />
          </a>

          <a
            href="mailto:ramanshrutilaya@gmail.com" 
            aria-label="Send us an email"
          >
            <FaEnvelope className="footer-icon email-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
